import { Formik, Field, Form } from "formik";
import CargarCvSvg from "../../Atoms/CargarCvSvg/CargarCvSvg";
import PostulacionFormikInputWraper from "../../Atoms/PostulacionFormikInputWraper/PostulacionFormikInputWraper";
import "./PostulacionFormik.scss";

const fields = [
	{ title: "Nombre", requestKey: "nombre" },
	{ title: "Apellido", requestKey: "apellido" },
	{ title: "Correo", requestKey: "correo" },
	{ title: "Teléfono", requestKey: "telefono" },
	{ title: "Profesión", requestKey: "profesion" },
	{ title: "Nacionalidad", requestKey: "nacionalidad" },
	{ title: "País", requestKey: "pais" },
	{ title: "Ciudad", requestKey: "ciudad" },
	{ title: "Cargo a postularse", requestKey: "cargo_a_postular" },
	{
		title: "Ultima experiencia laboral",
		requestKey: "ultima_experiencia_laboral",
	},
];

const PostulacionFormik = () => {
	return (
		<Formik
			initialValues={{
				[fields[0].requestKey]: "",
				[fields[1].requestKey]: "",
				[fields[2].requestKey]: "",
				[fields[3].requestKey]: "",
				[fields[4].requestKey]: "",
				[fields[5].requestKey]: "",
				[fields[6].requestKey]: "",
				[fields[7].requestKey]: "",
				[fields[8].requestKey]: "",
				[fields[9].requestKey]: "",
			}}
			onSubmit={(values, actions) => {
				console.log(values);
				actions.resetForm();
			}}
		>
			<Form className="postulacionFormik--form flex space-between center-cross-axis wrap">
				<PostulacionFormikInputWraper spanText={fields[0].title}>
					<Field
						name={fields[0].requestKey}
						type="text"
						className="postulacionFormik--input"
					/>
				</PostulacionFormikInputWraper>

				<PostulacionFormikInputWraper spanText={fields[1].title}>
					<Field
						name={fields[1].requestKey}
						type="text"
						className="postulacionFormik--input"
					/>
				</PostulacionFormikInputWraper>

				<PostulacionFormikInputWraper spanText={fields[2].title}>
					<Field
						name={fields[2].requestKey}
						type="text"
						className="postulacionFormik--input"
					/>
				</PostulacionFormikInputWraper>

				<PostulacionFormikInputWraper spanText={fields[3].title}>
					<Field
						name={fields[3].requestKey}
						type="text"
						className="postulacionFormik--input"
					/>
				</PostulacionFormikInputWraper>

				<PostulacionFormikInputWraper spanText={fields[4].title}>
					<Field
						name={fields[4].requestKey}
						type="text"
						className="postulacionFormik--input"
					/>
				</PostulacionFormikInputWraper>

				<PostulacionFormikInputWraper spanText={fields[5].title}>
					<Field
						name={fields[5].requestKey}
						type="text"
						className="postulacionFormik--input"
					/>
				</PostulacionFormikInputWraper>

				<PostulacionFormikInputWraper spanText={fields[6].title}>
					<Field
						name={fields[6].requestKey}
						type="text"
						className="postulacionFormik--input"
					/>
				</PostulacionFormikInputWraper>

				<PostulacionFormikInputWraper spanText={fields[7].title}>
					<Field
						name={fields[7].requestKey}
						type="text"
						className="postulacionFormik--input"
					/>
				</PostulacionFormikInputWraper>

				<PostulacionFormikInputWraper spanText={fields[8].title}>
					<Field
						name={fields[8].requestKey}
						type="text"
						className="postulacionFormik--input"
					/>
				</PostulacionFormikInputWraper>

				<PostulacionFormikInputWraper spanText={fields[9].title} allSpace>
					<Field
						name={fields[9].requestKey}
						as="textarea"
						rows="1"
						className="postulacionFormik--input"
					/>
				</PostulacionFormikInputWraper>

				<button
					type="submit"
					className="button light-blue postulacionFormik-button"
				>
					Cargar CV
					<span className="pl-10">
						<CargarCvSvg />
					</span>
				</button>
			</Form>
		</Formik>
	);
};

export default PostulacionFormik;
